import { useEffect } from 'react';
import { appConfig } from '../../../constants';

export const useCDFIRedirect = () => {
  useEffect(() => {
    if (
      window.location.pathname === '/' &&
      window.location.hash === '#/cdfi-page'
    ) {
      window.location.replace(`${appConfig.urls.cdfi}/cdfi-page`);
    }

    if (
      window.location.pathname === '/' &&
      window.location.hash === '#/cdfi-certification-page'
    ) {
      window.location.replace(`${appConfig.urls.cdfi}/cdfi-certification-page`);
    }
  }, []);
};
